import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import CmNotiziTableFilters from "components/subComponents/CmNotiziTableFilters";

import useCmNewsList from "hooks/list/useCmNewsList";

function ElencoCmNotizie() {
    const cmNewsListHook = useCmNewsList();

    const { navigateToNewNews, alertConfirmHook, dataTableHook } = cmNewsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <CmNotiziTableFilters cmNewsListHook={cmNewsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewNews}>
                        Nuova notizia
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoCmNotizie;
